// it will run even if we are on the operator login page
//TODO: fix it
(function($) {
    $(function() {
        $.ajax({
            url: `${window.api}/graveyards`,
            type: 'GET',
            headers: {
                Authorization: 'Bearer ' + window.iFrameToken,
            },
            success: function(res) {
                const response = Array.isArray(res) ? res : [res];
                window.allGraveyards = response;

                const graveyardsData = response.map(e => e.data);

                response.sort((a, b) => a.id - b.id);

                const linkToken = new URLSearchParams(window.location.search);
                const linkTokenValue = linkToken.get('linkToken');

                if (linkTokenValue || Cookies.get('logged_in')) {
                    $('#select--graveyard option').each(function() {
                        response.forEach((value, key) => {
                            if (value.name != $(this).val()) {
                                $(this).remove();
                            }
                        });
                    });

                    $('#select--graveyard')[0].sumo.reload();
                }

                //TODO: we put all graveyards' tiles on the map, which heavily affects performance, optimize it
                window.widget.addLayer(response, 1, {
                    ignoreClick: true,
                    layerName: 'graveYardsLayer',
                    hoverColor: 'rgb(245, 245, 61)',
                    hoverFill: 'rgba(245, 245, 61, 0.8)',
                    selectColor: 'red',
                    selectFill: 'rgba(250,0,0,.3)',
                    markers: {
                        markerName: 'graveYardsLayer',
                        markerDefault:
                            '<div class="markerDefault">\r\n    <svg class="markerIcon" width="40" height="40" viewBox="0 0 40 40" fill="#D99D26" xmlns="http://www.w3.org/2000/svg">\r\n        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 9H18V15H12V19H18V31H22V19H28V15H22V9Z" fill="white" />\r\n        <path fill-rule="evenodd" clip-rule="evenodd"\r\n            d="M17 9C17 8.44772 17.4477 8 18 8H22C22.5523 8 23 8.44772 23 9V14H28C28.5523 14 29 14.4477 29 15V19C29 19.5523 28.5523 20 28 20H23V31C23 31.5523 22.5523 32 22 32H18C17.4477 32 17 31.5523 17 31V20H12C11.4477 20 11 19.5523 11 19V15C11 14.4477 11.4477 14 12 14H17V9ZM19 10H21V16H27V18H21V30H19V18H13V16H19V10Z"\r\n            fill="#0A0A29" />\r\n        <g clip-path="url(#clip0_1096_774)">\r\n            <rect width="1" height="40" transform="translate(39)" fill="#D99D26" />\r\n        </g>\r\n    </svg>\r\n    <svg class="markerTriangle" width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">\r\n        <path d="M0 0H16L8 8L0 0Z" fill="#D99D26" />\r\n    </svg>\r\n    <div class="text">\r\n        <p></p>\r\n    </div>\r\n</div>',
                        markerAggregated: '<div class="markerAggregated"><p></p></div>',
                    },
                    //! if tiles true we will add the graveyards tile prop as a TileLayer
                    tiles: true,
                    childLayers: [
                        {
                            tableName: 'Parcel',
                            parentIdKey: 'graveyardId',
                            minZoomKey: 'parcelZoom',
                            maxZoomKey: 'graveZoom',
                            childBorderColor: '#F5F53D',
                            childFillColor: 'rgba(245, 245, 61, 0.3)',
                            labelKeys: [
                                {
                                    propName: 'publicName',
                                    divider: '',
                                },
                            ],
                            labelClass: 'label-grave',
                            labelAlways: true,
                        },
                        {
                            tableName: 'Grave',
                            parentIdKey: 'graveyardId',
                            minZoomKey: 'graveZoom',
                            childBorderColor: '#F5F53D',
                            childFillColor: 'rgba(245, 245, 61, 0.3)',
                            labelKeys: [
                                {
                                    propName: 'parcel',
                                    divider: '',
                                },
                                {
                                    propName: 'row',
                                    divider: '-',
                                },
                                {
                                    propName: 'pos',
                                    divider: '/',
                                },
                            ],
                            labelClass: 'label-grave',
                            selectable: true,
                        },
                    ],
                });

                // TODO: move this from here
                const queryParams = new URLSearchParams(window.location.search);
                const queryGraveyardId = queryParams.get('graveyard');
                const x = parseFloat(queryParams.get('x'));
                const y = parseFloat(queryParams.get('y'));

                if (queryGraveyardId) {
                    window.graveyard = queryGraveyardId;
                }

                var appended = false;

                $.loadGraveyard = function loadGraveyard() {
                    for (let j = 0; j < graveyardsData.length; j++) {
                        if (window.graveyard == graveyardsData[j].id) {
                            const currentGraveyard = graveyardsData[j];

                            if (currentGraveyard.crest !== false) {
                                $('.crest').attr('src', currentGraveyard.crest);
                                $('.crest-block').removeClass('visible-print');
                            } else {
                                $('.crest-block').addClass('visible-print');
                            }

                            if (currentGraveyard.title) {
                                $('.information-tab .tab-title').text(currentGraveyard.title);
                            }

                            if (currentGraveyard.address) {
                                $('.tab-address').text(currentGraveyard.address);
                                $('.tab-address').removeClass('visible-print');
                            } else {
                                $('.tab-address').addClass('visible-print');
                            }

                            if (currentGraveyard.seasonal_open_title) {
                                $('.open').text(currentGraveyard.seasonal_open_title);
                                $('.open').removeClass('visible-print');
                            } else {
                                $('.open').addClass('visible-print');
                            }

                            if (currentGraveyard.seasonal_opening_time) {
                                $('.open-time-light-black').text(
                                    currentGraveyard.seasonal_opening_time
                                );
                                $('.open-time-light-black').removeClass('visible-print');
                            } else {
                                $('.open-time-light-black').addClass('visible-print');
                            }

                            if (currentGraveyard.regular_opening) {
                                $('.opens-wrapper').removeClass('visible-print');
                                currentGraveyard.regular_opening.forEach(element => {
                                    if (appended != true) {
                                        $('.opens-wrapper').append(
                                            '<div class="d-flex space-between mb-8"><p class="open-time-black">' +
                                                element.days +
                                                '</p><p class="open-time-black">' +
                                                element.times +
                                                '</p></div>'
                                        );
                                    }
                                });
                                appended = true;
                            } else {
                                $('.opens-wrapper').addClass('visible-print');
                            }

                            if (currentGraveyard.contact_title) {
                                $('#contact-title').text(currentGraveyard.contact_title);
                                $('#contact-title').removeClass('visible-print');
                            } else {
                                $('#contact-title').addClass('visible-print');
                            }

                            if (currentGraveyard.email) {
                                $('.js-mail-wrapper').html(
                                    `<img src="assets/img/icons/icon-mail.svg" alt="" class="icon mr-8"><a href="mailto:${currentGraveyard.email}" class="contact-text" id="email">${currentGraveyard.email}</a>`
                                );
                                $('.js-mail-wrapper').removeClass('visible-print');
                            } else {
                                $('.js-mail-wrapper').addClass('visible-print');
                            }

                            if (currentGraveyard.phone) {
                                $('.js-phone-wrapper').html(
                                    `<img src="assets/img/icons/icon-phone.svg" alt="" class="icon mr-8"><a href="tel:${currentGraveyard.phone.replace(
                                        ' ',
                                        '',
                                        currentGraveyard.phone
                                    )}" class="contact-text">${currentGraveyard.phone}</a>`
                                );
                                $('.js-phone-wrapper').removeClass('visible-print');
                            } else {
                                $('.js-phone-wrapper').addClass('visible-print');
                            }

                            if (currentGraveyard.address) {
                                $('.js-address-wrapper').html(
                                    `<img src="assets/img/icons/icon-map.svg" alt="" class="icon mr-8"><a href="https://maps.google.com/?q=${currentGraveyard.address}" target="_blank" class="contact-text">${currentGraveyard.address}</a>`
                                );
                                $('.js-address-wrapper').removeClass('visible-print');
                            } else {
                                $('.js-address-wrapper').addClass('visible-print');
                            }

                            $('.modified-time').text(currentGraveyard.modified);
                        }
                    }
                };

                $(document).on('click', '.markerDefault', function() {
                    window.graveyard = $(this)
                        .parent()
                        .attr('id');
                    $('.information-tab').addClass('information-tab-visible');
                    $.loadGraveyard();
                });

                if (x && y) {
                    window.widget.zoomToCoord([x, y], 'Grave');
                } else if (queryGraveyardId) {
                    response.forEach(value => {
                        if (value.id == queryGraveyardId) {
                            window.geom = value.geom;
                            $('.information-tab').addClass('information-tab-visible');
                            $.loadGraveyard();
                            window.widget.zoomTo(
                                { geom: window.geom },
                                { padding: [30, 30, 30, 30] }
                            );
                        }
                    });
                }
            },
        });
    });
})(jQuery);
